export const SMARPANEL_ACCESSMONITOR_HOME_URL =
  'https://accessmonitor.acessibilidade.gov.pt/';
export const SMARPANEL_ACCESSMONITOR_RESULTS_BASE_URL =
  'https://accessmonitor.acessibilidade.gov.pt/results/';

export function buildSmarPanelAccessMonitorResultsUrl(pageUrl) {
  if (!pageUrl) return SMARPANEL_ACCESSMONITOR_HOME_URL;
  return `${SMARPANEL_ACCESSMONITOR_RESULTS_BASE_URL}${encodeURIComponent(pageUrl)}`;
}

export function getSmarPanelCurrentPortalPageUrl() {
  return window.location.href;
}

export function getSmarPanelPortalBaseUrl() {
  const { origin, pathname } = window.location;
  const normalizedPath = pathname.endsWith('/') ? pathname : `${pathname}/`;

  return `${origin}${normalizedPath}#/`;
}
